import React, { ReactElement } from 'react';

import { Icon } from '@pb/shared/ui/atoms/icon';
import { useIsDevice } from '@pb/hooks';
import { TAccountDetailsProperties } from './account-details.types';
import {
    StyledAccountDetailItems,
    StyledAccountDetailItem,
    StyledLink,
} from './account-details.styled';

export function AccountDetails({
    navigationItems,
    reference,
}: TAccountDetailsProperties): ReactElement {
    const isTabletLandscape = useIsDevice('tabletLandscape');
    const isDesktop = useIsDevice('desktop');
    const isLargeDevice = isTabletLandscape || isDesktop;

    return (
        <nav aria-label="Account management navigation" ref={reference}>
            <StyledAccountDetailItems>
                {navigationItems.map(
                    ({ icon, label, href, onClick }, index) => (
                        <StyledAccountDetailItem
                            key={`account-details-menu-${label}`}
                        >
                            <StyledLink to={href} onClick={onClick}>
                                {isLargeDevice && index === 0 ? null : (
                                    <Icon type={icon} color="black" size={24} />
                                )}
                                {label}
                            </StyledLink>
                        </StyledAccountDetailItem>
                    )
                )}
            </StyledAccountDetailItems>
        </nav>
    );
}
